import httpClient from './httpClient';

export const PROMOTION_BANNER_KEY_ENDPOINT = '/backoffice/product-promotion-banner-keys';

export const getPromotionBannerKeysAPI = async (params) => httpClient.get(`${PROMOTION_BANNER_KEY_ENDPOINT}`, { params });
export const getPromotionBannerKeyAPI = async (promotionBannerId) => httpClient.get(`${PROMOTION_BANNER_KEY_ENDPOINT}/${promotionBannerId}`);
export const createPromotionBannerKeyAPI = async (data) => httpClient.post(`${PROMOTION_BANNER_KEY_ENDPOINT}`, data);
export const updatePromotionBannerKeyAPI = async (id, data) => httpClient.put(`${PROMOTION_BANNER_KEY_ENDPOINT}/${id}`, data);
export const deletePromotionBannerKeyAPI = async (id) => httpClient.delete(`${PROMOTION_BANNER_KEY_ENDPOINT}/${id}`);
